export const RegionCodes = Object.freeze({
  US: 'us',
  EU: 'eu',
  AU: 'au'
});

const region_code_key = 'GoFormz.RegionCode';
export function InitializeRegion() {
  // check the path, query string, and the host first before falling back to local storage
  // this allows for navigating across regions after initial setup
  if (TryInitializeFromPath()) {
    return;
  }

  if (TryInitializeFromQueryString()) {
    return;
  }

  if (TryInitializeFromHost()) {
    return;
  }

  const existingRegionCode = getRegionCode();
  if (!!existingRegionCode) {
    return;
  }

  //default to storing the us
  localStorage.setItem(region_code_key, RegionCodes.US);
}

function TryInitializeFromPath() {
  const matchingRegionCode = getRegionCodeFromPath(window.location.pathname);
  if (matchingRegionCode) {
    localStorage.setItem(region_code_key, matchingRegionCode);
    return true;
  }

  return false;
}

function TryInitializeFromQueryString() {
  // try to pull from the query string first
  const queryString = window.location.search;
  const params = new URLSearchParams(queryString);
  const regionCodeFromQuery = params.get('regionCode') || '';
  const matchingRegionCode = Object.values(RegionCodes).find((rc) => regionCodeFromQuery.toLowerCase() == rc.toLowerCase());

  if (matchingRegionCode) {
    localStorage.setItem(region_code_key, matchingRegionCode);
    return true;
  }

  return false;
}

function TryInitializeFromHost() {
  // try to pull from the host first
  const host = window.location.host || '';
  const matchingRegionCode = Object.values(RegionCodes).find((rc) => host.toLowerCase().includes(`.${rc.toLowerCase()}.`));
  if (matchingRegionCode) {
    localStorage.setItem(region_code_key, matchingRegionCode);
    return true;
  }
  return false;
}

export function getRegionCodeFromPath(pathname: string) {
  const pathSegments = pathname.split('/').filter(Boolean);
  const possibleRegionCode = pathSegments[0] || '';

  return Object.values(RegionCodes).find((rc) => possibleRegionCode.toLowerCase() === rc.toLowerCase()) || null;
}

export function getRegionCode() {
  return localStorage.getItem(region_code_key) || RegionCodes.US;
}

export function clearRegionCode() {
  localStorage.removeItem(region_code_key);
}
